import { Component } from 'react'
import classNames from 'classnames'
import formatNumber from 'shared/format_number'
import { SharingGridButton } from 'shared'
import {
  DonateButton,
  ProjectComponent,
  SubscribeButton,
  CreateFundraisingEventButton,
  MatchingEventNotice,
  AdventMatchingNotice,
} from 'ppp'
import { TaxNotice, MatchingFundHelper, GtmHelper, formatCents, findApiV4Link } from 'shared'

export class Stats extends ProjectComponent {
  get isClosedOrCompleted() {
    return !!(this.state.project.completed_at || this.state.project.closed_at)
  }

  get completedNotice() {
    if (this.status == 'completed') {
      return <h4>{ I18n.t('projects.show.stats.completed_label') }</h4>
    }
  }

  componentDidUpdate(prevProps, prevState) {
    let matchingFund = MatchingFundHelper.locallyActiveMatchingFund(this.state.project)
    if (matchingFund && !this.state.active_matching_fund) {
      this.setState({ active_matching_fund: matchingFund })
    }
    if (this.state.loaded && !prevState.loaded) {
      GtmHelper.pushProductDetailImpression(this.state.project)
    }
  }

  render() {
    return <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', flexDirection: 'column' }}>
        <div>
          <ProgressBar percentage={this.state.project.progress_percentage} status={this.status} />
          <div className={classNames('generic-big-numbers is-compressed', `is-${this.status}`)}>
            {this.completedNotice}
            <ul className='list-unstyled'>
              <li className='is-left'>
                <span className='number'>{this.state.project.progress_percentage} %</span>
                <span className='legend'>{I18n.t('projects.show.stats.percentage_label')}</span>
              </li>
              <li className='is-middle'>
                <span className='number'>{formatNumber(this.state.project.donations_count)}</span>
                <span className='legend'>{I18n.t('projects.show.stats.donations_count_label')}</span>
              </li>
              {this.isClosedOrCompleted ? (
                <li className='is-right'>
                  <span className='number'>{formatCents(this.state.project.donated_amount_in_cents)}</span>
                  <span className='legend'>{I18n.t('projects.show.stats.donated_amount_label')}</span>
                </li>
              ) : (
                <li className='is-right'>
                  <span className='number'>{formatCents(this.state.project.open_amount_in_cents)}</span>
                  <span className='legend'>{I18n.t('projects.show.stats.open_amount_label')}</span>
                </li>
              )}
            </ul>
          </div>
        </div>

        <div>
          <AdventMatchingNotice
            activeFeatureFlag={this.props.adventPppBannerFeatureFlag === 'true'}
            active_matching_fund={this.state.active_matching_fund}
            project={this.state.project}
            status={this.status}
          />
          <MatchingEventNotice
            project={this.state.project}
            status={this.status}
            matchingEventUrl={this.props.matchingEventUrl}
          />
          <MatchingFundNotice
            project={this.state.project}
            status={this.status}
            active_matching_fund={this.state.active_matching_fund}
          />
          <DonateButton
            project={this.state.project}
            status={this.status}
            additionalClass='btn-block btn-large'
            active_matching_fund={this.state.active_matching_fund}
            gaAction='click donate_button__top'
          />

          {this.state.project.donations_prohibited || <TaxNotice />}

          <div className='m-y-sm'>
            {this.props.allowFundraisingEvents === 'true' && <CreateFundraisingEventButton
              project={this.state.project}
              ctaUrl={this.props.createFundraisingEventUrl}
              readmoreUrl={this.props.fundraisingEventLandingpageUrl}
            />}
            <SubscribeButton project={this.state.project} url={this.props.newsletterSubscriptionUrl} />
          </div>

          <SharingGridButton
            shareUrl={this.props.shareUrl}
            gaLabel='ppp_stats'
            platforms="['email', 'facebook', 'twitter', 'link', 'whatsapp', 'messenger']"
            modalHeader={I18n.t('projects.show.stats.share_modal_headline')}
            buttonLabel={I18n.t('projects.show.stats.share_button_label')}
            className='btn-large'
          />

          <ClosedNotice {...this.state.project.closed_notice} />
        </div>
      </div>
  }
}

// matching fund logo image should be sized 280x72
class MatchingFundNotice extends Component {
  render() {
    if (this.props.hidden || !this.props.active_matching_fund) return null
    return <div className="matching-fund-notice">
      <img src={ this.props.active_matching_fund.logo_url } alt={ this.props.active_matching_fund.title } />
      <p>{I18n.t('projects.show.stats.matching_fund_notice')}</p>
    </div>
  }
}

class ProgressBar extends Component {
  render() {
    if (this.props.status == 'completed') return null
    return <div className="progress generic-progress-bar mb-3">
      <div className="bar" style={{ width: `${this.props.percentage}%` }}></div>
    </div>
  }
}

class ClosedNotice extends Component {
  get url() {
    return findApiV4Link({ofObject: this.props, withRel: 'call_to_action'})
  }

  render() {
    if (!this.props.text) return null
    return <a href={ this.url } target='_blank'>{ this.props.text }</a>
  }
}
